import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Typography } from '@chilecompra/react-kit'
import { PUBLIC_URL } from '../../config/settings/environment'
import { WarningImg, ContainerCard as Card } from './BehaviorSection.styles'

/**
 * The Warning Message component.
 * Displays the warning message.
 */
const WarningMessage = ({ message }) => {
  return (
    <Card
      display="flex"
      enableBorder
      color="blank"
      margin="43px 0 44px 0"
      alignItems="center"
      height="243px"
      justifyContent="center"
    >
      <Box display="flex" alignItems="center" width="100%" height="203px" justifyContent="center">
        <WarningImg alt="No se encontraron resultados" src={`${PUBLIC_URL}/assets/images/warning.svg`} />
        <Typography
          color="black1"
          variant="body1"
          fontWeight="regular"
          fontSize="14px"
          lineHeight="18px"
          margin="0 0 0 33px"
          tabIndex="0"
          sx={{ maxWidth: '520px', 'white-space': 'pre-wrap' }}
        >
          {message}
        </Typography>
      </Box>
    </Card>
  )
}

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired
}

export default WarningMessage
